;$(function () {
	if(!document.getElementById('graph_ContestStat')) {
		return;
	}

	const ctx = document.getElementById('graph_ContestStat').getContext('2d');

	const gradientStroke = ctx.createLinearGradient(0, 0, 0, 300)
	gradientStroke.addColorStop(0, '#FED873')
	gradientStroke.addColorStop(1, '#5A4AFB')


	var chart = new Chart(ctx, {
		// The type of chart we want to create
		type: 'line',

		// The data for our dataset
		data: {
			labels: ['Сен 18', 'Окт 18', 'Ноя 18', 'Дек 18', 'Янв 19', 'Фев 19', 'Март 19', 'Апр 19', 'Май 19', 'Июнь 19', 'Июль 19', 'Сейчас'],
			datasets: [{
				fill: false,
				data: [0, 1, 2, 4, 20, 4, 40, 10, 9, 0, 1, 2, 4],
				borderWidth: 2,
				lineTension: 0,
        		pointHitRadius: 10,
				borderColor: gradientStroke,
				pointBorderColor: '#ffffff',
				pointBackgroundColor: '#ffffff',
				pointHoverBackgroundColor: '#FED873',
				pointHoverBorderColor: '#FED873'
			}]
		},
		responsive: true,
		// Configuration options go here
		options: {
			tooltips: {
				// Disable the on-canvas tooltip
				enabled: false,
				custom: customTooltips
			},
			legend: {
				display: false,
				align: 'start',
				titleAlign: 'center',
				bodyAlign: 'center'
			},
			layout: {
				padding: {
					left: 50,
					right: 120,
					top: 50,
					bottom: 25
				}
			},
			maintainAspectRatio: false,
			aspectRatio: 200 / 1400,
			scales: {
				yAxes: [{
					gridLines: {
						drawBorder: false,
						drawTicks: true,
						drawOnChartArea: false,
						color: '#ffffff',
						tickMarkLength: 5
					},
					ticks: {
						beginAtZero: false,
						//display: false,
						fontColor: '#ffffff',
						fontSize: 14,
					}
				}],
				xAxes: [{
					gridLines: {
						drawBorder: true,
						drawOnChartArea: false,
						color: '#ffffff',
						zeroLineWidth: 1,
						zeroLineColor: '#ffffff'
					},
					ticks: {
						beginAtZero: false,
						fontColor: '#ffffff',
						fontSize: 14
					}
				}]
			}
		},

	});


	function customTooltips(tooltip) {
		// Tooltip Element
		var tooltipEl = document.getElementById('chartjs-tooltip');

		if (!tooltipEl) {
			tooltipEl = document.createElement('div');
			tooltipEl.id = 'chartjs-tooltip';
			this._chart.canvas.parentNode.appendChild(tooltipEl);
		}

		// Hide if no tooltip
		if (tooltip.opacity === 0) {
			tooltipEl.style.opacity = 0;
			return;
		}

		// Set caret Position
		tooltipEl.classList.remove('above', 'below', 'no-transform');
		if (tooltip.yAlign) {
			tooltipEl.classList.add(tooltip.yAlign);
		} else {
			tooltipEl.classList.add('no-transform');
		}

		function getBody(bodyItem) {
			return bodyItem.lines;
		}

		// Set Text
		if (tooltip.body) {
			var bodyLines = tooltip.body.map(getBody);

			var innerHtml = '';

			bodyLines.forEach(function (body, i) {
				innerHtml +=  body ;
			});

			tooltipEl.innerHTML = innerHtml;
		}

		var positionY = this._chart.canvas.offsetTop;
		var positionX = this._chart.canvas.offsetLeft;

		// Display, position, and set styles for font
		tooltipEl.style.opacity = 1;
		tooltipEl.style.left = positionX + tooltip.caretX + 'px';
		tooltipEl.style.top = positionY + tooltip.caretY + 'px';
	}
});

class DateCharts {
  
  constructor(settings) {
    this.blockId = settings.blockId;
    this.dataLabel = JSON.parse(settings.dataLabel);
    this.dataCount = JSON.parse(settings.dataCount);
    
    if (document.getElementById(this.blockId)) {
      this.init();
    }
  }
  
  init() {
    const ctx = document.getElementById(this.blockId).getContext('2d');
    
    const gradientStroke = ctx.createLinearGradient(0, 0, 0, 300);
    gradientStroke.addColorStop(0, '#FED873');
    gradientStroke.addColorStop(1, '#5A4AFB');
    
    var chart = new Chart(ctx, {
      // The type of chart we want to create
      type: 'line',
      
      // The data for our dataset
      data: {
        labels: this.dataLabel,
        datasets: [{
          fill: false,
          data:  this.dataCount,
          borderWidth: 2,
          lineTension: 0,
          pointHitRadius: 10,
          borderColor: gradientStroke,
          pointBorderColor: '#ffffff',
          pointBackgroundColor: '#ffffff',
          pointHoverBackgroundColor: '#FED873',
          pointHoverBorderColor: '#FED873'
        }]
      },
      responsive: true,
      // Configuration options go here
      options: {
        tooltips: {
          // Disable the on-canvas tooltip
          enabled: false,
          custom: this.customTooltips
        },
        legend: {
          display: false,
          align: 'start',
          titleAlign: 'center',
          bodyAlign: 'center'
        },
        layout: {
          padding: {
            left: 50,
            right: 120,
            top: 50,
            bottom: 25
          }
        },
        maintainAspectRatio: false,
        aspectRatio: 200 / 1400,
        scales: {
          yAxes: [{
            gridLines: {
              drawBorder: false,
              drawTicks: true,
              drawOnChartArea: false,
              color: '#ffffff',
              tickMarkLength: 5
            },
            ticks: {
              beginAtZero: false,
              //display: false,
              fontColor: '#ffffff',
              fontSize: 14,
            }
          }],
          xAxes: [{
            gridLines: {
              drawBorder: true,
              drawOnChartArea: false,
              color: '#ffffff',
              zeroLineWidth: 1,
              zeroLineColor: '#ffffff'
            },
            ticks: {
              beginAtZero: false,
              fontColor: '#ffffff',
              fontSize: 14
            }
          }]
        }
      },
      
    });
  }
  
  
  customTooltips(tooltip) {
    // Tooltip Element
    var tooltipEl = document.getElementById('chartjs-tooltip');
    
    if (!tooltipEl) {
      tooltipEl = document.createElement('div');
      tooltipEl.id = 'chartjs-tooltip';
      this._chart.canvas.parentNode.appendChild(tooltipEl);
    }
    
    // Hide if no tooltip
    if (tooltip.opacity === 0) {
      tooltipEl.style.opacity = 0;
      return;
    }
    
    // Set caret Position
    tooltipEl.classList.remove('above', 'below', 'no-transform');
    if (tooltip.yAlign) {
      tooltipEl.classList.add(tooltip.yAlign);
    } else {
      tooltipEl.classList.add('no-transform');
    }
    
    function getBody(bodyItem) {
      return bodyItem.lines;
    }
    
    // Set Text
    if (tooltip.body) {
      var bodyLines = tooltip.body.map(getBody);
      
      var innerHtml = '';
      
      bodyLines.forEach(function (body, i) {
        innerHtml +=  body ;
      });
      
      tooltipEl.innerHTML = innerHtml;
    }
    
    var positionY = this._chart.canvas.offsetTop;
    var positionX = this._chart.canvas.offsetLeft;
    
    // Display, position, and set styles for font
    tooltipEl.style.opacity = 1;
    tooltipEl.style.left = positionX + tooltip.caretX + 'px';
    tooltipEl.style.top = positionY + tooltip.caretY + 'px';
  }
}
